import moment from 'moment';
import React, { useMemo } from 'react';
import { CustomOrderAddEventItemSC } from './custom-order-add-event-item.styled';
import TStore from '../../../../../../types/store';
import { connect } from 'react-redux';
import { readableColor } from 'polished';

type EventItemProps = {
  item: any;
  onClick?: () => void;
} & ReturnType<typeof mapStateToProps>;

const CustomOrderAddEventItem: React.FunctionComponent<EventItemProps> = ({
  item,
  onClick,
  selectedTag,
}) => {
  const { backgroundColor, textColor } = useMemo(() => {
    if (selectedTag) {
      return {
        textColor: readableColor(selectedTag.color),
        backgroundColor: selectedTag.color,
      };
    }
    return {
      backgroundColor: '#62AB81',
      textColor: 'white',
    };
  }, [selectedTag]);

  return (
    <CustomOrderAddEventItemSC
      onClick={onClick}
      textColor={textColor}
      backgroundColor={backgroundColor}
    >
      <div className="content">
        {moment(item.start).format('HH:mm')} - {moment(item.end).format('HH:mm')}
      </div>
    </CustomOrderAddEventItemSC>
  );
};

const mapStateToProps = (state: TStore) => ({
  selectedTag: state.reservationForm.selectedTag,
});

export default connect(mapStateToProps)(React.memo(CustomOrderAddEventItem));
